/* Ryse - Theoric: guardiao do video do hero do miolo.

   HISTORICO CURTO. Existiu um remedio de performance que escondia o video
   (display:none) e o PAUSAVA durante a rolagem, devolvendo depois. Isso fazia o
   video "pausar quando o dedo mexe e voltar quando solta". O remedio foi criado
   quando o hero carregava um mp4 pesado (1080p); hoje ele serve um 480p leve e
   o travamento que justificava a pausa nao existe mais. O remedio foi removido
   do theoric-pdp-conteudo.js — este arquivo agora so garante que o video volte
   a tocar quando isso for legitimo.

   REGRA: so chamamos play() quando (a) o video entra em tela, (b) a aba volta ao
   primeiro plano, ou (c) a rolagem parou. Nunca insistimos em cima de um pause
   feito pelo proprio sistema (iOS / Modo de Baixo Consumo), porque essa briga
   deixa o elemento num estado ruim. */
(function () {
  var OCIOSO = 160;

  function iniciar() {
    var video = document.querySelector('.tpn-miolo__hero-video');
    if (!video) return;

    /* rede de seguranca: se qualquer coisa tiver escondido o video, mostramos */
    var estilo = document.createElement('style');
    estilo.textContent = '.tpn-miolo__hero-video{display:block}';
    document.head.appendChild(estilo);
    video.style.display = '';

    var naTela = true;
    var ocioso;

    function tentarTocar() {
      if (document.hidden || !naTela) return;
      if (!video.paused) return;
      video.style.display = '';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        naTela = ents[0].isIntersecting;
        if (naTela) tentarTocar();
      }, { threshold: 0.05 }).observe(video);
    }

    window.addEventListener('scroll', function () {
      clearTimeout(ocioso);
      ocioso = setTimeout(tentarTocar, OCIOSO);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tentarTocar();
    });

    tentarTocar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();